export enum Status {
  all = '#/',
  active = '#/active',
  completed = '#/completed',
}
